/**
 *
 * @author Matthew Rawson @ 26/02/2018 15:24
 * @description
 * @notes
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import {get, isArray, isString, cloneDeep} from "lodash"

import connect from "@irati/store/connect"
import {Http403} from "@irati/ui/src/Errors"

import {AuthedCheckerContext, SetAuthStatus} from "../history/routing/AuthedChecker"
import id from "../id"


/**
 * Helper to determine if I have all required permissions
 *
 * @param permissions {array|string}
 * @param apps {object}
 * @returns {boolean}
 */
export const doIHavePermission = (permissions, apps) => {
  let hasPermission = true
  let requestedPermissions = cloneDeep(permissions)
  if (requestedPermissions && isString(requestedPermissions)) requestedPermissions = [requestedPermissions]
  if (!isArray(requestedPermissions)) throw new Error("Provide a string or an array of strings as permissions")

  requestedPermissions.forEach((permission) => {
    hasPermission = !get(apps, permission) ? false : hasPermission
  })

  return hasPermission
}


class HasPermissionTo extends Component {
  static propTypes = {
    permissions: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    children: PropTypes.node,
    Error: PropTypes.node,
    unauthed: PropTypes.bool,
    auth: PropTypes.object
  }

  static defaultProps = {
    permissions: [],
    children: null,
    Error: <Http403 />,
    unauthed: false,
    auth: {}
  }

  render() {
    const idNamespace = id("HasPermissionTo", this.props)
    const {auth, unauthed, children, Error} = this.props
    const {apps = {}} = auth

    const hasPermission = doIHavePermission(this.props.permissions, apps)

    return (
      <AuthedCheckerContext.Consumer>
        {({setAuthed}) =>
          <div id={idNamespace}>
            <SetAuthStatus setAuthed={setAuthed} unauthed={unauthed} />
            {hasPermission && children}

            {!hasPermission && Error}
          </div>
        }
      </AuthedCheckerContext.Consumer>
    )
  }
}

const mapStateToProps = ({auth}) => ({auth})

export default connect(mapStateToProps)(HasPermissionTo)
